import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/global.css";
import imageUrl from "./IMG_20250227_100103_636.jpg";  
import mlogo from "../assets/ntmlogo.jpg";

const Homepage = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/login"); // ✅ Redirects to login page on click
  };
  const handleClick10 = () => {
    navigate("/login10"); // ✅ Redirects to login page on click
  };

  return (
    <div className="container">
      {/* ✅ Big Logo */}
      <img src={mlogo} alt="Logo" className="big-logo" />

      <div className="click-box" onClick={handleClick}>
        <img src={imageUrl} alt="Aarambh Batch 2025-26" className="homepage-image" />
        <h1>Aarambh Batch 2024-25 (old)</h1>
      </div>
      <div className="click-box" onClick={handleClick10}>
        <img src="https://i.postimg.cc/pVKv3cLR/667423824369-IMG-9619.png" alt="Abhay Batch 2024-25" className="homepage-image" />
        <h1>Abhay Batch 2024-25 (old)</h1>
      </div>
    </div>
  );
};

export default Homepage;
